import { Filter, Filters } from "@/lib/filters/types";
import { ColumnFiltersState } from "@tanstack/react-table";

export const mapColumnFiltersStateToFilters = <P>(
  filters: ColumnFiltersState,
): Filters<P> => {
  return filters.map((filterData) => ({
    id: filterData.id,
    value: filterData.value as Filter,
  }));
};
